import zh from './i18n/locale/zh.json';
import en from './i18n/locale/en.json';
import vi from './i18n/locale/vi.json';
import th from './i18n/locale/th.json';
// import en from './i18n/locales/en';
const languagePacks = {
  zh, // 中文语言包
  en,
  vi,
  th
};

let currentLanguage = 'zh'; // 默认语言

export function setCurrentLanguage(lang) {
  currentLanguage = lang;
}

function getCurrentLanguage() {
  // 从 localStorage 中获取当前语言，默认为中文
  return currentLanguage;
}

function i18n(key) {
  const lang = getCurrentLanguage();
  const langObj = languagePacks[lang] || zh; // 如果语言包不存在，默认使用中文
  let result = langObj[key];
  if (result === undefined) {
    return key; // 如果未找到对应的翻译，返回 key 本身
  }
  return result;
}

export default {
  t: i18n
};
